import "./index.css";

export default function DynamicVariablesPanel({ templateType, onInsertVariable, dynamicVariables = {} }) {
  const generateVariables = () => {
    const variables = [];
    
    Object.entries(dynamicVariables).forEach(([category, fields]) => {
      fields.forEach(field => {
        variables.push({
          key: `{{${field}}}`,
          label: field.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
          category: category
        });
      });
    });
    
    return variables;
  };

  const allVariables = generateVariables();
  const categories = Object.keys(dynamicVariables);

  const copyToClipboard = (text) => {
    if (onInsertVariable) {
      onInsertVariable(text);
    } else {
      navigator.clipboard.writeText(text);
    }
  };

  const renderBadge = (variable) => (
    <span
      key={variable.key}
      className="badge bg-secondary variable-badge"
      title={variable.label}
      onClick={() => copyToClipboard(variable.key)}
    >
      <i className="bi bi-clipboard me-1"></i>
      {variable.key}
    </span>
  );

  return (
    <div className="card shadow-sm">
      <div className="card-header pb-2">
        <div className="d-flex align-items-center gap-2">
          <strong>Dynamic Variables</strong>
          <i
            className="bi bi-info-circle text-muted"
            title="Click a variable to copy it. It will be replaced with real data when email is sent."
          ></i>
        </div>
        <small className="text-muted">
          Click to insert into your email
        </small>
      </div>

      <div className="card-body">
        {categories.map((category) => (
          <div key={category} className="mb-3">
            <p className="section-title">{category.toUpperCase()}</p>
            <div className="d-flex flex-wrap gap-2">
              {allVariables
                .filter((v) => v.category === category)
                .map(renderBadge)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
